<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <k-card-header :items="headerItems"></k-card-header>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-if="loading">
      <v-progress-circular indeterminate size="50" />
    </v-container>

    <v-container v-if="!loading && workingInterest">
        <!-- Interest Settings -->
            <v-card class="detailCard">
              <v-card-title class="card-title">
                <span class="text-h6">Interest Settings</span>
              </v-card-title>
              <v-card-text class="ma-0 pa-0">
                <v-container>

                  <v-row justify="center" class="ma-0 pa-0">
                    <v-col cols="12" md="2" class="ma-0 pa-0">
                        <b>Core Calculates</b>
                    </v-col>
                    <v-col cols="12" md="4" class="ma-0 pa-0">
                      <v-radio-group v-model="workingInterest.coreInterestRateCalculation"
                        ref="coreInterestRateCalculation"
                        class="ma-0 pa-0">
                        <v-radio
                          value="QUAL_RATE"
                          label="Qual Rate"
                          class="ma-0 pa-0"
                          ref="qual_rate"
                          @click="setCoreNonProcessingAccrualMethodToExistingValue()"
                        />
                        <v-radio
                          value="ALL"
                          label="All"
                          name="all"
                          class="ma-0 pa-0"
                          ref="all"
                          @click="setCoreNonProcessingAccrualMethodToNull()"
                        />
                        <v-radio
                          value="NONE"
                          label="None"
                          name="none"
                          class="ma-0 pa-0"
                          ref="none"
                          @click="setCoreNonProcessingAccrualMethodToNull()"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>

                  <v-row justify="center" class="ma-0 pa-0">
                    <v-col cols="12" md="2" class="ma-0 pa-0">
                      <b>Balance Type</b>
                    </v-col>
                    <v-col cols="12" md="4" class="ma-0 pa-0">
                      <v-radio-group v-model="workingInterest.balanceType"
                        @change="onModification()"
                        ref="balanceType"
                        class="ma-0 pa-0">
                        <v-radio
                          value="CURRENT"
                          label="Current"
                          class="ma-0 pa-0"
                        />
                        <v-radio
                          value="COLLECTED"
                          label="Collected"
                          class="ma-0 pa-0"
                        />
                        <v-radio
                          value="AVAILABLE"
                          label="Available"
                          class="ma-0 pa-0"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>

                  <v-row justify="center" class="ma-0 pa-0">
                    <v-col cols="12" md="2" class="ma-0 pa-0">
                      <b>Calculation Method</b>
                    </v-col>
                    <v-col cols="12" md="4" class="ma-0 pa-0">
                      <v-radio-group v-model="workingInterest.calculationMethod"
                        @change="onModification()"
                        ref="calculationMethod"
                        class="ma-0 pa-0">
                        <v-radio
                          value="DAILY_BALANCE"
                          label="Daily Balance"
                          class="ma-0 pa-0"
                          ref="daily_balance"
                        />
                        <v-radio
                          value="AVERAGE_DAILY_BALANCE"
                          label="Average Daily Balance"
                          @click="setCompundingMethodToMonthly()"
                          class="ma-0 pa-0"
                          ref="average_daily_balance"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>

                  <v-row justify="center" class="ma-0 pa-0">
                    <v-col cols="12" md="2" class="ma-0 pa-0">
                      <b>Compounding Method</b>
                    </v-col>
                    <v-col cols="12" md="4" class="ma-0 pa-0">
                      <v-radio-group v-model="workingInterest.compoundingMethod"
                        @change="onModification()"
                        ref="compoundingMethod"
                        class="ma-0 pa-0"
                        :disabled="workingInterest.calculationMethod === 'AVERAGE_DAILY_BALANCE'">
                        <v-radio
                          value="DAILY"
                          label="Daily"
                          class="ma-0 pa-0"
                          ref="daily"
                        />
                        <v-radio
                          value="MONTHLY"
                          label="Monthly"
                          class="ma-0 pa-0"
                          ref="monthly"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>

                  <v-row justify="center" class="ma-0 pa-0">
                    <v-col cols="12" md="2" class="ma-0 pa-0">
                      <b>Rounding Method</b>
                    </v-col>
                    <v-col cols="12" md="4" class="ma-0 pa-0">
                      <v-radio-group v-model="workingInterest.roundingMethod"
                        @change="onModification()"
                        class="ma-0 pa-0">
                        <v-radio
                          value="STANDARD"
                          label="Standard Rounding"
                          class="ma-0 pa-0"
                        />
                        <v-radio
                          value="ALWAYS_ROUND_UP"
                          label="Always round up"
                          class="ma-0 pa-0"
                        />
                        <v-radio
                          value="ALWAYS_ROUND_DOWN"
                          label="Always round down"
                          class="ma-0 pa-0"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>

                  <v-row justify="center" class="ma-0 pa-0">
                    <v-col cols="12" md="2" class="ma-0 pa-0">
                        <b>Decimal Places</b>
                    </v-col>
                    <v-col cols="12" md="4" class="ma-0 pa-0">
                      <v-text-field align-center justify-center
                        ref="roundingDecimalPlaces"
                        label="Numeric value >=2 and <=8"
                        class="ma-0 pa-0"
                        dense
                        v-model="workingInterest.roundingDecimalPlaces"
                        v-on:input="onModification()"
                        type="number"
                        solo
                        :rules="[roundingRule]">
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row justify="center" class="ma-0 pa-0"
                    v-if="workingInterest.coreInterestRateCalculation === 'QUAL_RATE'">
                    <v-col cols="12" md="2" class="ma-0 pa-0">
                      <b>Non-Processing Day Accruals</b>
                    </v-col>
                    <v-col cols="12" md="4" class="ma-0 pa-0">
                      <v-radio-group v-model="workingInterest.coreNonProcessingAccrualMethod"
                        @change="onModification()"
                        ref="coreNonProcessingAccrualMethod"
                        class="ma-0 pa-0">
                        <v-radio
                          value="COMBINED_WITH_PREVIOUS"
                          label="Combined with PREVIOUS processing day"
                          class="ma-0 pa-0"
                        />
                        <v-radio
                          value="COMBINED_WITH_NEXT"
                          label="Combined with NEXT processing day"
                          class="ma-0 pa-0"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>

                  <v-row justify="center" class="ma-0 pa-0">
                    <v-col cols="12" md="2" class="ma-0 pa-0">
                      <b>Observe Leap Year</b>
                    </v-col>
                    <v-col cols="12" md="4" class="ma-0 pa-0">
                      <v-radio-group v-model="workingInterest.observeLeapYear"
                        @change="onModification()"
                        class="ma-0 pa-0">
                        <v-radio
                          v-bind:value="false"
                          label="No"
                          class="ma-0 pa-0"
                        />
                        <v-radio
                          v-bind:value="true"
                          label="Yes"
                          class="ma-0 pa-0"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>

                </v-container>
              </v-card-text>
            </v-card>

        <v-row class="pa-0 ma-0">
          <v-spacer></v-spacer>
          <!-- Reset button -->
          <v-col cols="auto" class="mr-auto">
              <v-btn
                color="primary"
                ref="resetButton"
                @click="initializeWorkingInterest()"
                :loading="cancelling"
                :disabled="!isDataModified || saving"
                >Reset
              </v-btn>
          </v-col>

          <!-- Save button -->
          <v-col cols="auto" class="mr-auto">
            <v-btn
              color="primary"
              ref="saveButton"
              @click="saveInterestSettings()"
              :loading="saving"
              :disabled="!isDataModified"
              >Save
            </v-btn>
          </v-col>
        </v-row>
    </v-container>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Inject, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';
import { KCardHeader, KCardHeaderBtn } from '@kasasa/fbase-components';
import {
  Interest,
  InterestSettingsResource,
} from '@/api/interestSettings';

@Component({
  computed: mapState(['fiId', 'configVersion']),
  components: {
    KCardHeader,
  },
})
export default class InterestSettings extends Vue {
  headerItems: any = [
    {
      text: 'Rewards Configuration',
      disabled: false,
      link: false,
    },
    {
      text: 'Interest Settings',
      disabled: true,
    },
  ];

  @Inject('InterestSettingsResource')
  interestSettingsResource!: InterestSettingsResource;

  fiId!: number;

  interest: Interest | null = null;

  workingInterest: Interest = InterestSettings.createEmptyInterest();;

  loading: boolean = false;

  cancelling: boolean = false;

  saving: boolean = false;

  isDataModified: boolean = false;

  valid: boolean = false;

  static createEmptyInterest() : Interest {
    return {
      coreInterestRateCalculation: '',
      balanceType: '',
      calculationMethod: '',
      compoundingMethod: '',
      roundingMethod: '',
      roundingDecimalPlaces: undefined,
      coreNonProcessingAccrualMethod: null,
      observeLeapYear: undefined,
    };
  }

  @Watch('fiId')
  mounted() {
    this.interest = null;
    this.loading = true;
    this.interestSettingsResource
      .get(this.fiId)
      .then((res: Interest) => {
        this.interest = res;
        this.initializeWorkingInterest();
      })
      .catch((error) => {
        this.showError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  roundingRule() {
    if (String(this.workingInterest.roundingDecimalPlaces) === '') {
      return 'Required';
    }
    if (this.workingInterest.roundingDecimalPlaces! < 2
        || this.workingInterest.roundingDecimalPlaces! > 8) {
      return 'Decimal Places should be between 2 and 8!';
    }
    return true;
  }

  initializeWorkingInterest() {
    this.isDataModified = false;
    if (this.interest) {
      Object.assign(this.workingInterest, this.interest);
    } else {
      this.workingInterest = InterestSettings.createEmptyInterest();
    }
  }

  onModification() {
    if ((this.workingInterest.roundingDecimalPlaces
        && this.workingInterest.roundingDecimalPlaces >= 2
        && this.workingInterest.roundingDecimalPlaces <= 8)
        && (this.workingInterest.coreInterestRateCalculation !== this.interest!.coreInterestRateCalculation
            || this.workingInterest.balanceType !== this.interest!.balanceType
            || this.workingInterest.calculationMethod !== this.interest!.calculationMethod
            || this.workingInterest.compoundingMethod !== this.interest!.compoundingMethod
            || this.workingInterest.roundingMethod !== this.interest!.roundingMethod
            || this.workingInterest.roundingDecimalPlaces !== this.interest!.roundingDecimalPlaces
            || this.workingInterest.coreNonProcessingAccrualMethod !== this.interest!.coreNonProcessingAccrualMethod
            || this.workingInterest.observeLeapYear !== this.interest!.observeLeapYear)) {
      this.isDataModified = true;
    } else {
      this.isDataModified = false;
    }
  }

  isValid() {
    if (this.workingInterest.coreInterestRateCalculation === '') {
      this.setError('Core Interest Rate Calculation is required!');
      return false;
    }
    if (this.workingInterest.balanceType === '') {
      this.setError('Balance Type is required!');
      return false;
    }
    if (this.workingInterest.calculationMethod === '') {
      this.setError('Calculation Method is required!');
      return false;
    }
    if (this.workingInterest.compoundingMethod === '') {
      this.setError('Compounding Method is required!');
      return false;
    }
    if (this.workingInterest.roundingMethod === '') {
      this.setError('Rounding Method is required!');
      return false;
    }
    if (this.workingInterest.coreInterestRateCalculation === 'QUAL_RATE'
        && this.workingInterest.coreNonProcessingAccrualMethod === null) {
      this.setError('Non-Processing Day Accruals is required!');
      return false;
    }
    if (this.workingInterest.observeLeapYear === undefined) {
      this.setError('Observe Leap Year is required!');
      return false;
    }
    return true;
  }

  saveInterestSettings() {
    this.saving = true;

    if (!this.isValid()) {
      this.saving = false;
      return;
    }

    this.interestSettingsResource
      .update(this.fiId, this.workingInterest!)
      .then((result: any) => {
        this.interest = result;
        this.initializeWorkingInterest();

        const al = new Alert('Interest Settings saved successfully.', NoticeClass.SUCCESS);
        al.setTimeout(5000);
        this.$store.dispatch('notices/add', al);
      })
      .finally(() => {
        this.saving = false;
      })
      .catch((error) => {
        this.showError(error);
      });
  }

  setCompundingMethodToMonthly() {
    this.workingInterest.compoundingMethod = 'MONTHLY';
    this.onModification();
  }

  setCoreNonProcessingAccrualMethodToNull() {
    this.workingInterest.coreNonProcessingAccrualMethod = null;
    this.onModification();
  }

  setCoreNonProcessingAccrualMethodToExistingValue() {
    this.workingInterest.coreNonProcessingAccrualMethod = this.interest!.coreNonProcessingAccrualMethod;
    this.onModification();
  }

  showError(error: any) {
    if (error.response && error.response.data && error.response.data.entity) {
      this.setError(error.response.data.entity);
    } else {
      this.setError('An unexpected error occurred.');
    }
  }

  setError(message: string) {
    const al = new Alert(message, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
</script>

<style lang="scss">
</style>
